import { ReactComponent as BibinoStore } from "src/scenes/DeviceInstall/icons/bibinoStore.svg";
import { ReactComponent as BarkioStore } from "src/scenes/DeviceInstall/icons/barkioStore.svg";
import { useTranslation } from "react-i18next";
import { SceneLayout } from "src/components/SceneLayout";
import { H2 } from "src/atoms/typography";
import { QRCodeCanvas } from "qrcode.react";
import environment from "src/utils/environment";
import { webLinks } from "src/browser/web-links";
import { Box, Flex, Spinner } from "@chakra-ui/react";

const imgStyles = { width: "56px", height: "56px" };

function renderCode(code) {
  return Array.from(code).map((number, id) => (
    <Box
      key={id}
      color="primary"
      fontSize="2rem"
      fontWeight="700"
      lineHeight="2.4rem"
      letterSpacing="0.3px"
      mr={id === 2 || id === 5 ? "5.3px" : "0px"}
    >
      {number}
    </Box>
  ));
}
export default function DisplayCode({ code, mode }) {
  const { t } = useTranslation();
  const hasCode = code != null;

  return (
    <SceneLayout
      centerProps={{ pb: mode === "fullScreen" ? "38px" : 0, width: "320px" }}
      center={
        <>
          {hasCode ? (
            <>
              <Flex
                flexDir="column"
                pos="relative"
                p="18px"
                borderRadius="16px"
                border="1px solid black"
                borderColor="black20"
                bg="white"
              >
                <QRCodeCanvas value={`${webLinks.index}/pairing/${code}`} size={210} level="Q" />
                <Box
                  pos="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50% , -50%)"
                  borderRadius="2rem"
                  border="8px solid"
                  borderColor="white"
                  bg="white"
                >
                  {environment.isBibino ? (
                    <BibinoStore style={{ ...imgStyles }} />
                  ) : (
                    <BarkioStore style={{ ...imgStyles }} />
                  )}
                </Box>
              </Flex>
              <Flex justifyContent="center" alignItems="center" width="222px" mt="8px">
                {renderCode(code)}
              </Flex>
              <H2 textAlign="center" mt="16px" color="highEmphasis">
                {t("pairing.scanOrEnter")}
              </H2>
            </>
          ) : (
            <Spinner />
          )}
        </>
      }
    />
  );
}
